import type {
  OptimizationFilterState,
  OptimizationUser,
} from '@/screens/optimization/types';

export function getRoleBasedOptimizationDefaults(
  user: OptimizationUser | null | undefined,
): OptimizationFilterState {
  const base: OptimizationFilterState = {
    scopeFilter: 'all',
    cloudAccountId: '',
    resourceOwnerId: '',
    subscriptionId: '',
    systemId: '',
    departmentId: '',
    statuses: ['Active'],
    chartScope: 'resource_owners',
  };

  if (!user) {
    return base;
  }

  if (user.is_admin || user.is_sponsor) {
    return { ...base, scopeFilter: 'all' };
  }

  if (user.is_resourceOwner) {
    return {
      ...base,
      scopeFilter: 'my',
      resourceOwnerId: String(user.id),
    };
  }

  if (user.is_cloudAccountOwner) {
    return { ...base, scopeFilter: 'supervised' };
  }

  if (user.is_departmentOwner) {
    return { ...base, scopeFilter: 'supervised' };
  }

  if (user.is_systemOwner) {
    return { ...base, scopeFilter: 'supervised' };
  }

  if (user.is_technical) {
    return { ...base, scopeFilter: 'my' };
  }

  return base;
}
